module.exports = __webpack_public_path__ + "img/unavailable_stocks.111c3884.svg";